import { Component, input, model } from '@angular/core';
import { FormCheckboxControl } from '@angular/forms/signals';

@Component({
  selector: 'ui-toggle',
  templateUrl: './toggle.html',
})
export class Toggle implements FormCheckboxControl {
  inputId = input<string | null>(null);
  ariaLabelledby = input<string | null>(null);
  ariaDescribedby = input<string | null>(null);

  readonly checked = model<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly touched = model<boolean>(false);

  protected onToggle(checked: boolean): void {
    this.checked.set(checked);
    this.touched.set(true);
  }
}
